import React, { useState, useEffect } from "react";
import axios from "axios";
import TypeApi from "../../api/TypeApi";
import GroupApi from "../../api/GroupApi";
import SourceApi from "../../api/SourceApi";
import { showError, showSuccess } from "../../utils/toastUtils";

function EditDetails({ sourceData, fetchSources, clearSelection }) {
  const [typeList, setTypeList] = useState([]);
  const [groupList, setGroupList] = useState([]);

  const [type, setType] = useState("");
  const [group, setGroup] = useState("");
  const [source, setSource] = useState("");
  const [errors, setErrors] = useState({});

  const fetchTypes = async () => {
    const res = await TypeApi.list();

    if (res.code === 200) {
      setTypeList(res.data);
    }
  };

  const fetchGroupsByType = async () => {
    const res = await GroupApi.list();
    if (res.code === 200) {
      setGroupList(res.data);
    }
  };

  useEffect(() => {
    fetchTypes();
  }, []);

  useEffect(() => {
    if (sourceData) {
      const tId = sourceData.type?._id || sourceData.type;
      const gId = sourceData.group?._id || sourceData.group;
      setType(tId || "");
      setGroup(gId || "");
      setSource(sourceData.source || "");
      if (tId) {
        fetchGroupsByType(tId, gId);
      }
    }
  }, [sourceData]);

  useEffect(() => {
    if (
      type &&
      (!sourceData || type !== (sourceData.type?._id || sourceData.type))
    ) {
      fetchGroupsByType(type);
    }
  }, [type]);

  const handleUpdate = async (e) => {
    e.preventDefault();

    const errs = {};
    if (!type) errs.type = "Select type";
    if (!group) errs.group = "Select group";
    if (!source.trim()) errs.source = "Source required";

    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }

    try {
      const res = await SourceApi.update({
        id: sourceData._id,
        type,
        group,
        source,
      });

      if (res.code === 200) {
        showSuccess(res.message);

        document.getElementById("closeOffcanvasBtnasdas").click();
        if (fetchSources) fetchSources();
        if (clearSelection) clearSelection();
      } else {
        showError(res.message);
      }
    } catch (err) {
      console.error("Update error:", err);
      showError(err.message || "Failed to update source");
    }
  };

  if (!sourceData) return null;

  return (
    <>
      <div className="modal-header">
        <h4 className="modal-title">Edit Lead Source</h4>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          id="closeOffcanvasBtnasdas"
        />
      </div>

      <form onSubmit={handleUpdate}>
        <div className="modal-body container">
          {/* Type */}
          <div className="mb-3">
            <label className="form-label">Lead Type</label>
            <select
              className="form-select"
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              <option value="">-- Select Type --</option>
              {typeList.map((t) => (
                <option key={t._id} value={t._id}>
                  {t.type}
                </option>
              ))}
            </select>
            {errors.type && <span className="text-danger">{errors.type}</span>}
          </div>

          {/* Group */}
          <div className="mb-3">
            <label className="form-label">Lead Group</label>
            <select
              className="form-select"
              value={group}
              onChange={(e) => setGroup(e.target.value)}
            >
              <option value="">-- Select Group --</option>
              {groupList.map((g) => (
                <option key={g._id} value={g._id}>
                  {g.group}
                </option>
              ))}
            </select>
            {errors.group && (
              <span className="text-danger">{errors.group}</span>
            )}
          </div>

          {/* Source */}
          <div className="mb-3">
            <label className="form-label">Lead Source</label>
            <input
              type="text"
              className="form-control"
              value={source}
              onChange={(e) => setSource(e.target.value)}
            />
            {errors.source && (
              <span className="text-danger">{errors.source}</span>
            )}
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            data-bs-dismiss="modal"
            onClick={clearSelection}
          >
            Close
          </button>
          <button type="submit" className="btn btn-primary">
            Update
          </button>
        </div>
      </form>
    </>
  );
}

export default EditDetails;
